import * as React from 'react';
import { Form, Text, Select } from 'react-form';
import { _ } from "@src/services/i18n";
import {isLevel} from "@src/services/user";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing
interface LocalProps extends Props {
    filters?: any;
    onSearch: Function;
}
interface LocalState extends State {
    filters?: any;
    dealid?: any;
    value1?: any;
    value2?: any;
}

// style
const style = css`
    form {
        ${mixin.form}

        .fields {
            > * {
                width: 25%;
            }
        }
    }
`;

debugger;

// component
export class Search extends Proto<LocalProps, LocalState> {


    constructor(props) {
        super(props);

        this.state = {
            dealid: null,
        };

    }

    async search( filters ) {
        const { onSearch } = this.props;
        this.setState({
            filters,
        });
        if (onSearch) {
            onSearch( filters );
        }
    }


    loadCustomers = (ev) => {

        if (ev === null || ev === undefined) {
            this.setState({dealid: null});
        } else {
            this.setState({dealid: ev});
        }

    };

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const {  } = this.props;
        const { data, filters = {}, items = [] } = this.state;

        var customers = [];
        // var customers = data.customers.map( v => ({ value: v.id, label: v.name }));
        if (this.state.dealid !== null) {
            const found = data.dealers.find(element => element.dealerid == this.state.dealid);

            var all_customers = data.customers.filter((value,index) => {
                return found.customers.includes(value.id);
            });

            customers = all_customers.map( v => ({ value: v.id, label: v.name }));
        } else {
            customers = data.customers.map( v => ({ value: v.id, label: v.name }));
        }


        const dealers = data.dealers.map( v => ({ value: v.dealerid, label: v.name }));

        /*let sites = [];
        if (filters.customer) {
            sites = data.customers.filter( v => v.id === filters.customer )[0].sites.map( v => ({ value: v.id, label: v.name }));
        }*/
        const technologies = data.technologies.map( v => ({ value: v.id, label: v.name }));

        const yesNo = [
            { value: 0, label: _('search_no', 'Fleet') },
            { value: 1, label: _('search_yes', 'Fleet') },
        ];
        
		return (
            <>
            <Box
                title={_('search_title', 'Fleet')}
                collapsed={false}
            >
                <div className={style}>
                    <Form onSubmit={(v) => this.search(v)}>
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onReset={formApi.resetAll}
                            onChange={() => setTimeout(() => { this.setState({ filters: formApi.getFormState().values }); }) }
                        >
                            <div className="fields">
                                {isLevel("hyster") &&
                                <article>
                                    <label htmlFor="dealer">{_('search_filters_dealer', 'Fleet')}</label>
                                    <Select field="dealer" id="dealer" options={this.addDefaultOption(dealers)} placeholder={false} className="form-control" onChange={ this.loadCustomers } />
                                </article>
                                }
                                <article>
                                    <label htmlFor="customer">{_('search_filters_customer', 'Fleet')}</label>
                                    <Select field="customer" id="customer" placeholder={false} className="form-control"
                                            options={ this.addDefaultOption(customers) } />
                                </article>
                                {/*sites &&
                                <article>
                                    <label htmlFor="site">Site</label>
                                    <Select field="site" id="site" options={sites} className="form-control" />
                                </article>
                                */}
                                <article>
                                    <label htmlFor="brand">{_('search_filters_brand', 'Fleet')}</label>
                                    <Text field="brand" id="brand" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="is_new">{_('search_filters_newbattery', 'Fleet')}</label>
                                    <Select field="is_new" id="is_new" options={this.addDefaultOption(yesNo)} placeholder={false} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="technology">{_('search_filters_technology', 'Fleet')}</label>
                                    <Select field="technology" id="technology" options={this.addDefaultOption(technologies)} placeholder={false} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="voltage">{_('search_filters_voltage', 'Fleet')}</label>
                                    <Text field="voltage" id="voltage" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="capacity">{_('search_filters_capacity', 'Fleet')}</label>
                                    <Text field="capacity" id="capacity" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="truck_sn">{_('search_filters_truck_sn', 'Fleet')}</label>
                                    <Text field="truck_sn" id="truck_sn" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="truck_model">{_('search_filters_truck_model', 'Fleet')}</label>
                                    <Text field="truck_model" id="truck_model" className="form-control" />
                                </article>
                            </div>
                            <footer>
                                <button type="reset" className="btn btn-secondary">
                                {_('search_filters_reset', 'Fleet')}
                                </button>
                                <button type="submit" className="btn btn-primary">
                                {_('search_filters_submit', 'Fleet')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Box>
            </>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Fleet/Search.tsx